import { Injectable } from '@angular/core'
import { Observable, BehaviorSubject, catchError } from 'rxjs'
import { HttpClient } from '@angular/common/http'
import { UserPreferencesDB } from '../../models/userPreferences.model'

@Injectable({
  providedIn: 'root',
})
export class UserService extends BehaviorSubject<any[]> {
  constructor(private _http: HttpClient) {
    super([])
  }
  getUserList(): Observable<any[]> {
    return this._http
      .get<any[]>('/users/userlist')
      .pipe(catchError(this.handleError))
  }
  getUserEmailList(): Observable<string[]> {
    return this._http
      .get<any[]>(`/users/GetUserEmailList`)
      .pipe(catchError(this.handleError))
  }
  getRoleList(): Observable<any> {
    return this._http
      .get<any>('/users/' + '0' + '/roles/Getrolelist')
      .pipe(catchError(this.handleError))
  }
    getBranchList(): Observable<any> {
    return this._http
      .get<any>('/api/auth/GetBranches')
      .pipe(catchError(this.handleError))
  }
      getproductList(): Observable<any> {
    return this._http
      .get<any>('/api/auth/GetProductTypes')
      .pipe(catchError(this.handleError))
  }
  AssignRoleList(r: any): Observable<any> {
    return this._http
      .post<any>('/users/' + '0' + '/roles/AssignRole', r)
      .pipe(catchError(this.handleError))
  }
  getEmailTypeList(): Observable<any> {
    return this._http
      .get<any>('/api/Types/EmailTypes')
      .pipe(catchError(this.handleError))
  }
  getproductTypeList(): Observable<any> {
    return this._http
      .get<any[]>('/api/Types/productTypelist')
      .pipe(catchError(this.handleError))
  }
  getRolebyUserId(id: string): Observable<any> {
    return this._http
      .get('/users/' + `${id}` + '/roles/GetbyUserId')
      .pipe(catchError(this.handleError))
  }
  getUserIdbyProductTypeId(id: string): Observable<any> {
    return this._http
      .get('/api/Types/' + `${id}` + '/GetEmailUsers')
      .pipe(catchError(this.handleError))
  }
  SaveprofileusersInfo(u: any): Observable<object> {
    return this._http
      .post<object>('/api/auth/SaveProfileUser', u)
      .pipe(catchError(this.handleError))
  }

  getUserPreferences(): Observable<UserPreferencesDB> {
    return this._http
      .get<any>('/users/getuserpreferences')
      .pipe(catchError(this.handleError))
  }

  saveUserPreferences(u: UserPreferencesDB): Observable<any> {
    return this._http
      .post<any>('/users/saveuserpreferences', u)
      .pipe(catchError(this.handleError))
  }

  private handleError(error: Response | any) {
    let errMsg: string
    if (error instanceof Response) {
      const body = error.json() || ''
      const err = body || JSON.stringify(body)
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`
    } else {
      errMsg = error.message ? error.message : error.toString()
    }
    return Promise.reject(errMsg)
  }
}
